<div class="main-container">
	<h3>Digital log forms</h3>

	<ng-container *ngIf="formRequests?.length">
		<div class="main-form">
			<div class="form-expandable-container" *ngIf="{ isFormExpanded: false } as state">
				<details [attr.open]="state.isFormExpanded ? '' : null">

					<summary [style.display]="!state.isFormExpanded ? 'flex' : 'none'" (click)="state.isFormExpanded = !state.isFormExpanded; $event.preventDefault();">
						<span>{{ filtersFormGroup.get('year').value }} - {{ filtersFormGroup.get('formRequest').value?.formName }}</span>
					</summary>

					<form [formGroup]="filtersFormGroup">
						<mat-form-field>
							<mat-select formControlName="formRequest">
								<mat-option *ngFor="let option of formRequests" [value]="option">{{ option.formName }}
								</mat-option>
							</mat-select>
						</mat-form-field>
	
						<mat-form-field>
							<mat-select formControlName="year">
								<mat-option *ngFor="let year of visibleYears" [value]="year">{{ year }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</form>
				</details>

				<button mat-icon-button (click)="state.isFormExpanded = !state.isFormExpanded" [class.is-expanded]="state.isFormExpanded"><mat-icon>expand_more</mat-icon></button>
			</div>

			<app-legend [legendBullets]="legendBullets"></app-legend>

			<app-loader [isInline]="true" *ngIf="isLoadingTimeline"></app-loader>
			<vtr-calendar *ngIf="selectedDate && !isLoadingTimeline" [year]="selectedDate" [config]="config">
			</vtr-calendar>
		</div>
	</ng-container>

	<div class="empty-message-container" *ngIf="!formRequests?.length">There are no digital log forms!</div>
</div>